import React, { Component, Fragment } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect, NavLink } from 'react-router-dom';

import { MyContext } from '../../context/Context'

import Login from '../components/pages/user/Login'
import Register from '../components/pages/user/Register'
import Header_Main from '../components/layout/Header_Main'
import FooterMain from '../components/layout/Footer_Main'

// import Footer from '../components/layout/Footer'
import LandingPage from '../components/pages/home/LandingPage'


import CardList from '../components/pages/cards/CardList';
import CadreList from '../components/pages/cards/CadreList';

import ProjectList from '../components/pages/organization/ProjectList'
import MasterForm from '../components/pages/cards/MasterForm'

import AddCard from '../components/pages/cards/AddCard';
import PropTypes from 'prop-types';
import { MyStore } from '../../services/Store'




import Confirm from '../components/pages/organization/components/Confirm'

// import Profile from '../components/pages/user/Profile'
// import Profile3 from '../components/pages/user/Profile3'


import UserOrgans from '../components/pages/organization/UserOrgans'   //route is /cadre
import Dashboard from '../components/pages/organization/Dashboard'   


import CreateAccount from '../components/pages/user/CreateAccount'
// import Cadre from '../components/pages/organization/Cadre'   //route is /cadre/:id

import MasterFormEdit from '../components/pages/cards/MasterFormEdit'

// import EditCard2 from '../components/pages/cards/EditCard_copy';

import { Sidebar, Menu, Icon, Segment } from 'semantic-ui-react'
import firebase from 'firebase'

// import { createBrowserHistory } from "history";
import history from './history'

// const browserHistory = createBrowserHistory();


class Data extends Component {

  constructor(props) {
    super(props);
    this.handler = this.handler.bind(this);
    this.state = {
      animation: 'push',
      direction: 'top',
      dimmed: false,
      visible: false,
     currentUser : MyStore.auth().currentUser
    }
 


  }


  // This method will be sent to the child component
  handler(value) {
    console.log('------------running handle------')

    let tempVisible = this.state.visible;
    if (tempVisible) {
      this.setState({ visible: false, direction: 'top' })
    }
    else {
      this.setState({ visible: true, direction: 'top' })
    }
    if (value == true) {
      this.setState({ visible: false })
    }

    // this.setState({
    //   messageShown: true
    // });
  }
      
  onLogoutHandler =()  => {
    console.log('------------------ onLogoutHandler ------------------------ ')
    localStorage.removeItem('token');
    localStorage.removeItem('expDate');
    localStorage.removeItem('userId');
    this.context.dispatch({ type: 'AUTH_LOGOUT', payload: { token: null, localId: null } });
    firebase.auth().signOut();
    this.handler(true)
    return(<Redirect to='/'/>)
    // this.props.history.push('/login');
    // this.props.action(true)
};





  componentDidMount() {
    const token = localStorage.getItem('token');
    if (!token) {
      this.context.dispatch({
        type: 'AUTH_LOGOUT',
        payload: { token: null, localId: null }
      });
    } else {
      const expDate = new Date(localStorage.getItem('expDate'));
      if (expDate < new Date()) {
        this.context.dispatch({
          type: 'AUTH_LOGOUT',
          payload: { token: null, localId: null }
        });
      } else {
        const localId = localStorage.getItem('userId');
        this.context.dispatch({
          type: 'AUTH_LOGIN',
          payload: { token: token, localId: localId }
        });
      }
    }
  }


  componentWillUnmount() {
    // this.onLogoutHandler();
    console.log('componentWillUnmount -- data.js')
}


  // handleAnimationChange = (animation) => () =>
  //   this.setState((prevState) => ({ animation, visible: !prevState.visible }), this.handleDirectionChangeTrue('top'))



  // handleDirectionChange = (direction) => () =>
  //   this.setState({ direction, visible: false })

  // handleDirectionChangeTrue = (direction) => () =>
  //   this.setState({ direction, visible: true })


  // ButtonMultipleConditionals = () => (
  //   <Button.Group style={{ align: "center", padding: '0px' }}>
  //     <Button onClick={this.handleAnimationChange('overlay')}>Open Menu</Button>
  //     <Button.Or />

  //     <Button onClick={this.handleDirectionChange('left')}
  //     >Close Menu</Button>
  //   </Button.Group>
  // )






  render() {
    const { animation, direction, visible } = this.state
    let routes = ''
    if (this.context.auth.token) {

     routes = (
      <Switch>
        <Route exact path="/" component={LandingPage} />
        {/* <Route exact path="/organization/:id" component={Organization}/> */}

        <Route exact path="/cadre/:id" component={Dashboard}/>
        {/* <Route exact path="/cadre/:id" component={Cadre}/> */}
        {/* <Route exact path="/cadre/:id/dashboard/create" component={MasterForm} /> */}
        <Route exact path="/projectlist/:id" component={MasterFormEdit} />
        <Route exact path="/cardlist/card/edit/:id" component={MasterFormEdit} />
        {/* http://localhost:3000/cadre/-LwLujWwcsr6szQxZYer/dashboard */}
        <Route  path={`/cadre/${this.context.oid}/dashboard/card/:id`} component={MasterFormEdit} />
        <Route exact path="/cadre/:id/dashboard" component={Dashboard} />

        {/* <Route exact path="/cardlist" component={CadreList} /> */}
        <Route exact path="/cardlist/card/add" component={AddCard} />
        {/* <Route exact path="/cardlist/card/edit/:id" component={MasterFormEdit} /> */}
        {/* <Route exact path="/cardlist/card/edit3/:id" component={EditCard} /> */}
        {/* <Route exact path="/cardlist/card/edit2/:id" component={EditCard2} /> */}

        <Route exact path="/cadre" component={UserOrgans}/>

      <Route exact path='/confirm/:id' component={Confirm} />
      <Route exact path="/logout" component={this.onLogoutHandler} />

        {/* <Route exact path="/login" component={Login}/> */}
        <Redirect to="/" />
        {/* <Route component={NotFound} /> */}
      </Switch>
    );
    }
    // if (!this.context.auth.token) {
      // if(this.state.currentUser == undefined){
        else{
      routes = (
        <Switch>
          <Route exact path="/" component={LandingPage} />
          {/* <Route exact path="/cardlist" component={CardList}/> */}
          {/* <Route exact path="/cardlist/card/add" component={AddCard} /> */}
          {/* <Route exact path="/cardlist/card/edit/:id" component={MasterFormEdit} /> */}
          {/* <Route exact path="/cardlist/card/edit3/:id" component={EditCard} /> */}
          {/* <Route exact path="/cardlist/card/edit2/:id" component={EditCard2} /> */}

          {/* <Route exact path="/dashboard/:id" component={Dashboard}/> */}
          
          <Route exact path='/confirm/:id' component={Confirm} />

          <Route exact path="/register" component={Register} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/createAccount" component={CreateAccount}/>
     
          <Redirect to="/" />
          {/* <Route component={NotFound} /> */}
        </Switch>
      );
    }


    return (
      <Fragment>
        <Router 
        // history={history}
        >

       

          <Header_Main action={this.handler} />


          <Sidebar.Pushable as={Segment}    style={{  background: "transparent",
    border: "0px solid transparent",
    boxShadow: "none",
    padding: "0em 0em",
 }}   >
            {routes}
            <VerticalSidebar
              animation={animation}
              direction={direction}
              visible={visible}>




            </VerticalSidebar ></Sidebar.Pushable>
          <FooterMain />
          {/* <Footer/> */}

        </Router>
      </Fragment>
    )
  }
}




















const NavLinkWithChildrenFunc = ({ to, exact = false, children, ...rest }) => (
  <Route path={to} exact={exact}>
    {({ match }) => (
      <NavLink to={to} {...rest}>
        {typeof children === "function" ? children(match) : children}
      </NavLink>
    )}
  </Route>
);


const VerticalSidebar = ({ animation, direction, visible }) => (
  <Sidebar
    as={Menu}
    animation={animation}
    direction={direction}
    icon='labeled'
    inverted
    // vertical
    visible={visible}
    style={{
      display:'flex',
      flexDirection: 'column',
      minHeight: '20px',
      width: '27%',
      height: '50%',
      // transition: ' all 0.5s ease',

    }}
  // width='thin'
  >

{/* 
    <NavLinkWithChildrenFunc exact to="/cardlist/card/add">
      {match => (
        <Menu.Item active={!!match} color='teal'>
          <Icon name="wpforms" />
         create a new project
                </Menu.Item>
      )}
    </NavLinkWithChildrenFunc> */}


    {/* <Menu.Item style={{ cursor: "pointer" }} color='teal'>
      <Icon name="users" />
      Members in your Organization
            </Menu.Item> */}

  
 


    <NavLinkWithChildrenFunc exact to="/cadre" >
      {match => (
        <Menu.Item active={!!match} color='teal'>
          <Icon name="hospital outline" />
          cadre
                </Menu.Item>
      )}
    </NavLinkWithChildrenFunc>


    <NavLinkWithChildrenFunc exact to="/profile" >
      {match => (
        <Menu.Item active={!!match} color='teal'>
         <Icon name="user" />
      Profile
                </Menu.Item>
      )}
    </NavLinkWithChildrenFunc>

    {/* <Route exact path="/organization/:id" component={Profile3}/> */}


    {/* <Menu.Item style={{ cursor: "pointer" }} color='teal'>
      <Icon name="address card" />
      Your Profile
    </Menu.Item> */}




    {/* <NavLinkWithChildrenFunc exact to="/" >
      {match => (
        <Menu.Item active={!!match} color='teal'>
          <Icon name="home" />
          Home
                </Menu.Item>
      )}
    </NavLinkWithChildrenFunc> */}

    <NavLinkWithChildrenFunc exact  to="/logout"  >
    {/* // onClick={() => onLogoutHandler()}> */}
      {match => (
        <Menu.Item active={!!match} color='teal'>
       <Icon name="log out" />
            Logout
                </Menu.Item>
      )}
    </NavLinkWithChildrenFunc>

{/* 
    <Menu.Item style={{ cursor: "pointer" }}>
      <Icon name="log out" />
      Logout
            </Menu.Item> */}


  </Sidebar>
)

VerticalSidebar.propTypes = {
  animation: PropTypes.string,
  direction: PropTypes.string,
  visible: PropTypes.bool,
}





export default Data
Data.contextType = MyContext;
